// extracted by mini-css-extract-plugin
export var activeLink = "navigation-module--activeLink--68b83";
export var container = "navigation-module--container--133f4";
export var freePostage = "navigation-module--freePostage--010b3";
export var navLink = "navigation-module--navLink--c4b6a";
export var navStyle = "navigation-module--navStyle--8e7cd";
export var specialLink = "navigation-module--specialLink--517ac";
export var specialLinkMobile = "navigation-module--specialLinkMobile--dbcf9";